







































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { getdatalist, getecharttimeData } from "@/api/equipAnalyseManage";
import moment, { isMoment } from "moment";
import { drawEchart } from "./../../publicjs/echarts";
@Component({
  name: "equipManage",
  components: { Pagination },
})
export default class extends Vue {
  [x: string]: any;

  mounted() {
    this.getSession();
    this.$nextTick(() => {
      this.getlist(this.listQuery);
    });
  }

  private starttime = {
    disabledDate: (time: any) => {
      if (this.listQuery.endtime) {
        return time.getTime() > new Date(this.listQuery.endtime).getTime();
      } else {
        return time.getTime() > Date.now();
      }
    },
  };
  private endtime = {
    disabledDate: (time: any) => {
      if (this.listQuery.begintime) {
        return (
          time.getTime() > Date.now() ||
          time.getTime() < new Date(this.listQuery.begintime).getTime()
        );
      } else {
        return time.getTime() > Date.now();
      }
    },
  };
  private equipstate: any = "";
  private listQuery: any = {
    name: "",
    page: 1,
    limit: 10,
    begintime: null,
    endtime: null,
    timetype: "",
    equipstate: -1,
    orgnaziid: "",
  };
  private options = [
    {
      label: "新品",
      value: 0,
    },
    {
      label: "正常",
      value: 1,
    },
    {
      label: "堪用",
      value: 2,
    },
    {
      label: "待修",
      value: 3,
    },
    {
      label: "在修",
      value: 4,
    },
  ];
  private tableData: any = [];
  private total: number = 0;
  private dialogXdata: any = []; //对话框x轴数据
  private dialogYdata: any = []; //对话框Y轴数据
  private echartsXdata: any = []; //使用率echarts横轴数据
  private echartsYdata: any = []; //使用率echarts横轴数据echarts纵轴数据
  private echartsFirstLoad: any = []; //初次加载时候echarts数组
  private echartsFirstUpdate: any = []; //echarts下拉项选择改变后值
  private button = [{ name: "周" }, { name: "月" }, { name: "年" }];
  private isactive = 4; //按钮得比较值
  private type = "primary"; //tag按钮类型
  private isloading = true;
  private allParams = {
    listLoading: false,
    dataValue: "",
    dialogVisible: false,
    title: "",
    dataType: "week",
    beginType: "请选择开始时间",
    endType: "请选择结束时间",
    endtime: "",
    begintime: "",
    dateText: "yyyy 第 WW 周",
  };
  private getParams: any = {
    id: "",
    type: "",
    timetype: "",
    begintime: null,
    endtime: null,
    usertype: "",
    orgnizeid: "",
  };

  private searchData() {
    (this.$refs.tableref as any).clearSelection();
    if (this.listQuery.timetype != "") {
      if (this.listQuery.begintime == null && this.listQuery.endtime == null) {
        this.$message({
          message: "请选择起始和结束时间",
          type: "warning",
        });
      } else {
        this.getlist(this.listQuery);
      }
    } else {
      this.listQuery.begintime = null;
      this.listQuery.endtime = null;
      this.getlist(this.listQuery);
    }

    // if (this.listQuery.begintime != null && this.listQuery.endtime != null) {
    //   this.getlist(this.listQuery);
    // } else if (
    //   this.listQuery.begintime == null &&
    //   this.listQuery.endtime == null
    // ) {
    //   this.getlist(this.listQuery);
    // } else {
    //   this.$message({
    //     message: "请清空或者选择时间范围",
    //     type: "warning",
    //   });
    // }
  }
  private async clearSearch() {
    this.listQuery.name = "";
    this.listQuery.equipstate = -1;
    this.getlist(this.listQuery);
  }
  private changeequip() {
    this.listQuery.equipstate = this.equipstate;
    this.getlist(this.listQuery);
  }
  private resetSearch() {
    this.listQuery.name = "";
    this.listQuery.page = 1;
    this.listQuery.limit = 10;
    this.listQuery.begintime = null;
    this.listQuery.equipstate = "-1";
    this.equipstate = "";
    this.listQuery.endtime = null;
    this.listQuery.timetype = "";
    this.isactive = 4;
    (this.$refs.tableref as any).clearSelection();
    this.getlist(this.listQuery);
  }
  private getSession() {
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    this.getParams.id = parma.userid;
    this.getParams.usertype = parma.usertype;
    this.getParams.orgnizeid = parma.orgnizeid;
    this.listQuery.orgnaziid = parma.orgnizeid;
  }
  // 展示echarts图

  private async showEcharts(parm: any, index: number) {
    this.dialogXdata = [];
    this.dialogYdata = [];
    this.getParams.id = parm.id;
    this.getParams.timetype = this.listQuery.timetype;
    this.getParams.begintime = this.listQuery.begintime;
    this.getParams.endtime = this.listQuery.endtime;
    let diaxdata: any = [];

    this.allParams.dialogVisible = true;
    if (index == 1) {
      this.getParams.type = 1;
      await getecharttimeData(this.getParams).then((res) => {
        if (res.code === 200) {
          res.data.itemhour.itemhour.forEach((item: any) => {
            diaxdata.push(item.xdata);
            this.dialogYdata.push(item.ydata);
          });

          diaxdata.forEach((item: any) => {
            item =
              item.substring(0, 10) +
              "\xa0" +
              item.substring(item.length - 19, 29);
            this.dialogXdata.push(item);
          });
          drawEchart(
            this.$refs.bar_dv,
            this.dialogXdata,
            this.dialogYdata,
            "使用次数分布图",
            "使用率",
            "器材名称"
          );
          // this.drawEcharts("usetime", this.dialogXdata, this.dialogYdata);
        }
      });
      // drawEchart(
      //   this.$refs.bar_dv,
      //   this.dialogXdata,
      //   this.dialogYdata,
      //   "使用时长分布图"
      // );
      // this.drawEchart(this.$refs.bar_dv, this.dialogXdata, this.dialogYdata);
    } else {
      this.getParams.timetype = 2;
      await getecharttimeData(this.getParams).then((res) => {
        if (res.code === 200) {
          res.data.itemhour.itemhour.forEach((item: any) => {
            diaxdata.push(item.xdata);
            this.dialogYdata.push(item.ydata);
          });
          diaxdata.forEach((item: any) => {
            item =
              item.substring(0, 10) +
              "\xa0" +
              item.substring(item.length - 19, 29);
            this.dialogXdata.push(item);
          });

          drawEchart(
            this.$refs.bar_dv,
            this.dialogXdata,
            this.dialogYdata,
            "使用次数分布图",
            "时间",
            "数量"
          );
        }
      });
    }
  }
  // 获取列表
  private async getlist(parm: any) {
    this.allParams.listLoading = true;
    await getdatalist(parm).then((res) => {
      if (res.code === 200) {
        this.isloading = false;
        this.tableData = res.data.items;
        this.total = res.data.total;
        if (this.listQuery.page == 1) {
          this.$nextTick(() => {
            this.toogleTbale(this.tableData);
          });
        }
        this.tableData.forEach((item: any) => {
          this.echartsXdata.push(item.equipname);
          this.echartsYdata.push(item.usage);
        });
        drawEchart(
          this.$refs.echartsMidDiv,
          this.echartsXdata,
          this.echartsYdata,
          "使用率分布图",
          "使用率",
          "器材名称"
        );
        // this.drawEcharts("useg", this.echartsXdata, this.echartsYdata);
      }
    });
  }
  private toogleTbale(rows: any) {
    if (rows) {
      rows.forEach((row: any) => {
        (this.$refs.tableref as any).toggleRowSelection(row);
      });
    }
  }
  // 表格数据多选事件
  private async handleSelectionChange(val: any) {
    this.echartsXdata = [];
    this.echartsYdata = [];
    this.echartsFirstUpdate = val;
    this.echartsFirstUpdate.forEach((item: any) => {
      this.echartsXdata.push(item.equipname);
      this.echartsYdata.push(item.usage);
    });
    drawEchart(
      this.$refs.echartsMidDiv,
      this.echartsXdata,
      this.echartsYdata,
      "使用率分布图",
      "使用率",
      "器材名称"
    );
    // this.drawEcharts("useg", this.echartsXdata, this.echartsYdata);
  }
  private handleSelection(val: any) {}
  // 时间控件改变事件

  private changeFocus() {
    if (this.listQuery.timetype == "") {
      this.$message({
        message: "请先选择时间粒度",
        type: "warning",
      });
    }
  }
  // 更改按钮状态
  private changetage(parm: any) {
    //将点击的元素的索引赋值给bian变量
    this.listQuery.begintime = null;
    this.listQuery.endtime = null;
    if (parm == 0) {
      this.listQuery.timetype = "week";
      this.allParams.beginType = "开始周";
      this.allParams.endType = "结束周";
      this.allParams.dateText = "yyyy 第 WW 周";
    } else if (parm == 1) {
      this.listQuery.timetype = "month";
      this.allParams.beginType = "开始月";
      this.allParams.endType = "结束月";
      this.allParams.dateText = "";
    } else if (parm == 2) {
      this.listQuery.timetype = "year";
      this.allParams.beginType = "开始年";
      this.allParams.dateText = "";
      this.allParams.endType = "结束年";
    }
    this.isactive = parm;
  }

  private cellStyle({
    row,
    column,
    rowIndex,
    columnIndex,
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return "text-align:center";
  }

  private rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return "text-align:center";
  }
  private handleClose() {
    this.allParams.dialogVisible = false;
  }
  // 绑定表格初次加载默认显示加载数据方法
  private toogleData(arr: any) {
    if (arr) {
      const result = this.tableData.find();
    }
  }

  private async handleSizeChange(val: number) {
    this.listQuery.limit = val;
    (this.$refs.tableref as any).clearSelection();
    this.getlist(this.listQuery);
  }
  private async handleCurrentChange(val: number) {
    this.listQuery.page = val;
    await getdatalist(this.listQuery).then((res) => {
      if (res.code === 200) {
        this.isloading = false;
        this.tableData = res.data.items;
        this.total = res.data.total;
      }
    });
  }
  private open() {
    this.$nextTick(() => {
      //  执行echarts方法
      // drawelineEcharts();
      // this.drawEcharts("", this.dialogXdata, this.dialogYdata);
      // drawEchart("", this.dialogXdata, this.dialogYdata, "");
    });
  }
}
